import { ValidationRule } from '@/mixins/validation/validator';

export const same =
	(comparableProvider: () => any): ValidationRule =>
	value => {
		const valid = value === comparableProvider();

		return valid || 'Values are not identical';
	};
